<div id="loader" *ngIf="loading"></div>
    <!-- add admin documents -->
    <div class="input-container" id="Check4"*ngIf="role=='superadmin'||role=='adminbanque'">
      <label for="myCheck4">Afficher le formulaire d'ajout de document</label>
      <input type="checkbox" id="myCheck4" (click)="myFunction4()">
    </div>
    <div id="bodycontainer4">
      <div class="container-fluid"> 
        <fieldset>
          <div class="form-group row">
            <label class="col-sm-12 col-form-label"> Charger document</label>
            <div class="col-sm-12">
              <input type="text"placeholder='titre du document' class="form-control"[(ngModel)]="title">
            </div>
            <div class="col-sm-12">
              <textarea name="" id="" cols="30" rows="2"placeholder='insérer commentaire'class="form-control"[(ngModel)]="comm"></textarea>
            </div>
              <div class="col-sm-12">
                <input type="file"  class="form-control inputFile" accept="application/pdf"(change)="onImagePick($event)">
              </div>
              <div class="col-sm-12 mt-3">
                <label class="form-label">Types de profil</label>
                <div *ngFor="let type of userTypes">
                  <input type="checkbox" [id]="type.value" [(ngModel)]="type.selected" name="userTypes">
                  <label [for]="type.value">{{ type.label }}</label>
                </div>
              </div>
          </div>
          <button class="btn btn-success" (click)="afficher4()"> <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Valider</button>
        </fieldset>
      <p>{{ errormsg }}</p>
    </div>
    </div>
<div class="container-fluid"*ngIf="documentslist">
  <h2 style="text-align: center;">Liste des documents</h2> 
   <table class="table table-striped" id="tablebordered">
            <thead>
                <tr>
                  <th scope="col" [style.top]="inverseOfTranslation">Titre</th>
                  <th scope="col" [style.top]="inverseOfTranslation">Commentaire</th>
                  <th scope="col" [style.top]="inverseOfTranslation">Consultable Par:</th>
                  <th scope="col" [style.top]="inverseOfTranslation">Date de création</th>
                  <th scope="col" [style.top]="inverseOfTranslation">Document joint</th>
                </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let doc of documentslist, let i=index">
                    <td>{{doc.titre}}</td>
                    <td>{{doc.commentaire}}</td>
                    <td>{{filteracteur(doc.profils)}}</td>
                    <td>{{doc.created | customDate}}</td>
                    <td >
        <a href="{{doc.ficheurl}}" target="_blank">Aperçu document</a>
                    </td>  
                    <td>
                      <button class="btn btn-danger" (click)="deleteDocument(doc._id)"*ngIf="role=='superadmin'">Supprimer</button>
                    </td>
                  </tr>
                </tbody>
        </table>
</div>